import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  width: 100%;
  row-gap: 20px;
  grid-template-columns: 1fr;
  justify-content: center;
  padding-bottom: 20px;
`;
